exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ccls--col--mdc0ZgAc {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.ccls--row--zm0h3EUP {\r\n  margin-top: 16px;\r\n}\r\n\r\n\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/profile/cclcEditor/ccls.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;CACtB;;AAED;EACE,iBAAiB;CAClB","file":"ccls.css","sourcesContent":[".col {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.row {\r\n  margin-top: 16px;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"col": "ccls--col--mdc0ZgAc",
	"row": "ccls--row--zm0h3EUP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/profile/cclcEditor/ccls.css
// module id = 404
// module chunks = 0